import React from "react";
import ReactDOM from "react-dom/client";
import { WagmiProvider, createConfig, http } from "wagmi";
import { baseSepolia, sepolia } from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { metaMask, injected, coinbaseWallet } from "wagmi/connectors";
import { farcasterFrame } from "@farcaster/miniapp-wagmi-connector";
import App from "./App.jsx";
import "./index.css";
import { arcTestnet, unichainSepolia, worldchainSepolia } from "./utils/constants";

// Configure Wagmi with MetaMask as the primary connector
const config = createConfig({
  chains: [arcTestnet, baseSepolia, sepolia, unichainSepolia, worldchainSepolia],
  transports: {
    [arcTestnet.id]: http(),
    [baseSepolia.id]: http(),
    [sepolia.id]: http(),
    [unichainSepolia.id]: http(),
    [worldchainSepolia.id]: http(),
  },
  connectors: [
    // MetaMask as the primary/dedicated connector
    metaMask({
      dappMetadata: {
        name: "Arc Bridge",
        url: typeof window !== "undefined" ? window.location.origin : "https://arc-bridge.app",
      },
    }),
    // Coinbase Wallet
    coinbaseWallet({ appName: "Arc Bridge" }),
    // Farcaster miniapp connector
    farcasterFrame(),
    // Generic injected fallback for other browser wallets
    injected({ target: "injected" }),
  ],
});

// Create React Query client
const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
